import { Suspense, useRef } from "react";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { RouterProvider } from "react-router-dom";
import LoadingBar, { LoadingBarRef } from "react-top-loading-bar";
import { PersistGate } from "redux-persist/integration/react";

import PageLoader from "./page-loader";
import { persistor } from "./redux/store";
import rootRoutes from "./routes";
import BuildNumbers from "./components/shared/BuildNumbers";

function App() {
  const ref = useRef<LoadingBarRef | null>(null);

  return (
    <PersistGate loading={null} persistor={persistor}>
      <Suspense fallback={<PageLoader />}>
        <RouterProvider
          router={rootRoutes}
          fallbackElement={<LoadingBar color="#cbff10" ref={ref} />}
        />
      </Suspense>
      <BuildNumbers />
    </PersistGate>
  );
}

export default App;
